/**
 * Lamination Line 1 API — backed by the `lam1_readings` table via the
 * `/lam1` router. Endpoints live in `lamLine.ts`, shared with Lamination 2.
 *
 * This is the current source for Lamination 1's extruder signals. They used to
 * be wired to the blender-1 PLC and read from `kgreading` via
 * `/blender/extruders*` (see `extruder.ts`); when Line 1's PLC was replaced
 * they moved onto the new unit, and the `kgreading` extruder columns have read
 * as noise since. `blender.ts` remains correct for the Lam 1 blender weights.
 *
 * `getLam1ShiftRolls` and `getLam1RollEvents` return stale/empty data until two
 * PLC-side settings are fixed — its real-time clock is unset and shift
 * scheduling is switched off — so nothing charts them yet.
 */
import { makeLamApi } from "./lamLine";
import type {
  LamGroupBy,
  LamSpeedRow,
  LamCurrentRow,
  LamStatusRow,
  LamCurrentStatus,
  LamShiftRollsRow,
  LamRollEvent,
} from "./lamLine";

export type Lam1GroupBy = LamGroupBy;
export type Lam1SpeedRow = LamSpeedRow;
export type Lam1CurrentRow = LamCurrentRow;
export type Lam1StatusRow = LamStatusRow;
export type Lam1CurrentStatus = LamCurrentStatus;
export type Lam1ShiftRollsRow = LamShiftRollsRow;
export type Lam1RollEvent = LamRollEvent;

/** This line's calls as one object, for components shared with the other line. */
export const lam1Api = makeLamApi("/lam1");
const lam1 = lam1Api;

export const getLam1ScrewSpeeds = lam1.getScrewSpeeds;
export const getLam1MotorCurrents = lam1.getMotorCurrents;
export const getLam1Status = lam1.getStatus;
export const getLam1CurrentStatus = lam1.getCurrentStatus;
export const getLam1ShiftRolls = lam1.getShiftRolls;
export const getLam1RollEvents = lam1.getRollEvents;
